import React from 'react';
import * as styles from './detailedCurriculum.module.scss';

const Row = ({ label, children, variant }) => (
  <div className={`${styles.prow} ${variant ? styles[variant] : ''}`}>
    <div className={styles.lab}>{label}</div>
    <div className={styles.txt}>{children}</div>
  </div>
);

const ProjectCard = ({ p }) => {
  return (
    <article className={styles.pj} id={p.id}>
      <div className={styles.pjH}>
        <span className={styles.code}>{p.code}</span>
        <div>
          <h3>{p.name}</h3>
          <div className={styles.tl}>{p.tagline}</div>
        </div>
        <div className={styles.meta}>
          <span className={styles.sk}>{p.skill}</span>
        </div>
      </div>
      {p.scenario ? (
        <Row label="Scenario">{p.scenario}</Row>
      ) : (
        <Row label="What it is">{p.whatItIs}</Row>
      )}
      {!p.scenario && <Row label="Business problem">{p.problem}</Row>}
      <Row label="You build">{p.build}</Row>
      <Row label="Proof it works">{p.proof}</Row>
      {p.ships && (
        <Row label="Ships as" variant="ship">
          {p.ships} {p.stretch && <em>Stretch:</em>} {p.stretch}
        </Row>
      )}
      <Row label="Why it matters" variant="why">
        {p.why}
      </Row>
    </article>
  );
};

export default ProjectCard;
